module.exports = __webpack_public_path__ + "img/calendar.60b93f8.svg";